<div class="archive-confirm-dialog">
    <h1 mat-dialog-title tabIndex="0">
        {{'Archive.MoveToArchive' | translate}}
        <i class="dolineo-icon dolineo-icon-close dolineo-icon-gray"
           matTooltip="{{'Common.Close' | translate}}"
           matTooltipPosition="below"
           matTooltipClass='below-top'
           (click)="dialogRef.close()"></i>
    </h1>

    <div mat-dialog-content>
        <p>{{data.content | translate}}</p>
        <p>{{data.extraContent | translate}}</p>

        <div *ngIf="data.useBy?.length > 0" class="useBy">
            <span>{{data.useByContent | translate}} </span>

            <div *ngFor="let use of data.useBy">- {{use}}</div>
        </div>
    </div>

    <div mat-dialog-actions class="dialog-footer">
        <button (click)="dialogRef.close()" [mat-dialog-close]="false" mat-button
                class="cancel-button">{{'Common.Cancel' | translate}}</button>
        <button [mat-dialog-close]="true" mat-button color="primary"
                class="dolineo-button blue-button">{{'Common.IConfirm' | translate}}</button>
    </div>
</div>
